import { useRecording, useTranscription } from "@daily-co/daily-react"
import { Captions, CircleDot } from "lucide-react"

/**
 * Read-only recording and transcription indicators. In the main room both are started by the
 * host's Daily meeting token, exactly as with the legacy renderer; inside a breakout room the
 * first attendee starts transcription (see `useBreakoutTranscription`).
 */
export function RecordingTranscriptionBadges({ compact = false }: { compact?: boolean }) {
  const { isRecording } = useRecording()
  const { isTranscribing } = useTranscription()
  if (!isRecording && !isTranscribing) return null
  return (
    <div data-testid="call-media-badges" className="flex items-center gap-2">
      {isRecording && (
        <span aria-label="Recording" title="Recording" className="flex items-center gap-1 rounded-full bg-red-500/20 px-2 py-0.5 text-[11px] font-semibold text-red-200">
          <CircleDot aria-hidden="true" className="h-3 w-3 animate-pulse" />
          {!compact && "Recording"}
        </span>
      )}
      {isTranscribing && (
        <span aria-label="Transcribing" title="Transcribing" className="flex items-center gap-1 rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-semibold text-white/80">
          <Captions aria-hidden="true" className="h-3 w-3" />
          {!compact && "Transcribing"}
        </span>
      )}
    </div>
  )
}
